<template>
    <fragment>

        <div v-if="dataStore.showReportWindow" class="report-window">

            <form v-on:submit.prevent="submitReport">

                <div class="form-group">
                    <label for="report-text">{{ language.label_report }}</label>
                    <textarea v-model="reportComment" class="form-control" id="report-text" rows="3"></textarea>
                </div>

                <button :title="language.send" type="submit" class="btn btn-primary">{{ language.send }}</button>

            </form>

        </div>

        <div v-if="markerFeedback && dataStore.feedbackOverride" class="feedback">
            <p>{{ language.report_message }}</p>
        </div>

    </fragment>
</template>

<script>

import axios from "axios";
import dataStore from "../../store";
import { Fragment } from 'vue-fragment'

export default {

    components: {
        Fragment
    },

    inject: [ 'language' ],


    data() {
        return {
            dataStore: dataStore,
            reportComment : '',
            markerFeedback : false
        };
    },

    methods: {

        submitReport: function() {
            this.dataStore.showReportWindow = false;
            this.markerFeedback = true;
            this.dataStore.reported.push(this.dataStore.currentToReport)
            this.dataStore.feedbackOverride = true;

            axios.post(
                `/api/save-report`, {
                    marker_id : this.dataStore.currentToReport,
                    comment : this.reportComment
                }
            )
            .then(response => {
                this.dataStore.currentToReport = null
                this.reportComment = '';
            })
            .catch(err => {
                console.error(err);
            });

            setTimeout(() => {
                this.markerFeedback = false;
                this.dataStore.feedbackOverride = false;
            } , 5000);
        }

    }
};
</script>

